@let filesForCustomer =
  requestFilesPersonType() === RequestFilesPersonType.CLIENT;
<!--от заказчика-->
@let request = $request();
@let isLoading = !!(isLoading$ | async);
@let canDeleteFiles = permissionService.canDeleteFiles$ | async;
@let canUploadFiles = $canUploadFiles();
@let canDeleteContractorFiles =
  permissionService.canDeleteContractorFiles$ | async;
@let isInsideSummary = $isInsideSummary();
@let renderModalLayoutInline = $renderModalLayoutInline();
@let catUploadInProgress = $catUploadInProgress();
@let catsUploadProgress = $catsUploadProgress();
@let filesUploadingTotalByCat = $filesUploadingTotalByCat();
@let filesProcessedCountByCat = $filesProcessedCountByCat();

@if (renderModalLayoutInline) {
  <section class="mt-2">
    @if (!filesForCustomer) {
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.photos',
          filterFn: isPhotoCat.bind(this),
          filterFnParam: 'fileRenamePrefix',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.scans',
          filterFn: isScanCat.bind(this),
          filterFnParam: 'fileRenamePrefix',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.other',
          filterFn: filterOtherFiles.bind(this),
        }"
      ></ng-container>
    } @else {
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.important',
          filterFn: isImportantCat.bind(this),
          filterFnParam: 'id',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.other',
          filterFn: filterNonImportantFiles.bind(this),
          filterFnParam: 'id',
        }"
      ></ng-container>
    }
  </section>
} @else if (isInsideSummary) {
  <div class="mt-6 flex gap-5">
    <!--левый блок с единичными документами-->
    <section class="w-full">
      <div class="x-card x-card_size_m x-white">
        @for (
          fileCat of catsWithOneDocFile(fileCats);
          track fileCat.id;
          let last = $last
        ) {
          @let file = getFiles(fileCat.id)[0];
          @let isContractorCategory =
            getFileCat(file.catId)?.isContractorFileCat;
          @let requestedToDelete = fileIsRequestedToDelete(file);
          <p
            class="x-font-body-5-bold flex items-center gap-2 cursor-pointer x-text-dark-main hover:opacity-75"
            [ngClass]="{ 'mb-4.5': !last }"
            (mouseover)="hoveredFileCatId = fileCat.id"
            (mouseleave)="hoveredFileCatId = null"
          >
            <span
              (click)="downloadFile(file)"
              class="flex items-center gap-2"
              [ngClass]="{ 'x-text-red': requestedToDelete }"
            >
              <x-file-preview
                [src]="file.path | filePreviewUrl"
                [title]="file.filename"
                [fallback]="fileIsImage(file) ? [getFileUrl(file)] : undefined"
                [fallbackIcon]="
                  fileIsImage(file) ? '@tui.image' : '@tui.file-text'
                "
                [badge]="file.filename | fileExtension"
                [width]="64"
                [height]="64"
              ></x-file-preview>
              <span
                [tuiHint]="file?.filename"
                tuiHintDirection="top-start"
                tuiHintAppearance="dark"
              >
                {{ fileCat.name }}
              </span>
            </span>
            @if (hoveredFileCatId === fileCat.id) {
              @if (
                (canDeleteFiles ||
                  (isContractorCategory && canDeleteContractorFiles)) &&
                !requestedToDelete
              ) {
                <tui-icon
                  icon="@tui.x"
                  class="bg-(--x-color-red) text-white rounded-full cursor-pointer size-6 text-base"
                  tuiHintAppearance="dark"
                  tuiHintDirection="end-top"
                  [tuiHint]="
                    ('request_form.files.hint_delete_file' | translate) +
                    file?.filename
                  "
                  (click)="deleteFile(file, $event)"
                />
              } @else if (!requestedToDelete) {
                <tui-icon
                  icon="@tui.x"
                  class="bg-(--x-color-red) text-white rounded-full cursor-pointer size-6 text-base"
                  tuiHintAppearance="dark"
                  tuiHintDirection="end-top"
                  [tuiHint]="
                    ('request_form.files.hint_request_to_delete' | translate) +
                    file.filename
                  "
                  (click)="createFileDeleteRequest(file)"
                />
              }
              @if (requestedToDelete) {
                <tui-icon
                  icon="@tui.x"
                  class="bg-(--x-color-red) text-white rounded-full cursor-pointer size-6 text-base"
                  tuiHintAppearance="dark"
                  tuiHintDirection="end-top"
                  [tuiHint]="
                    ('request_form.files.hint_cancel_request_to_delete'
                      | translate) + file.filename
                  "
                  (click)="createFileDeleteRequest(file)"
                />
              }
            }
          </p>
        } @empty {
          <x-empty-block
            [title]="
              'request_form.files.single_doc_file_cats_empty_message'
                | translate
            "
          />
        }
      </div>
    </section>
    <!--правый блок с медиа файлами и категориями с файлами с больше чем 1 файлом-->
    <section class="w-full">
      <div class="x-card x-card_size_m x-white">
        @let moreThanOneFileCats = catsWithMoreThanOneFileOrImages(fileCats);
        @for (
          fileCat of moreThanOneFileCats;
          track fileCat.id;
          let last = $last
        ) {
          @let files = getFiles(fileCat.id);
          @let isContractorCategory = fileCat.isContractorFileCat;
          <div [ngClass]="{ 'mb-8': !last }">
            <p
              class="x-font-body-4-bold flex items-center gap-2 cursor-pointer x-text-dark-main hover:opacity-75 mb-3"
              (mouseover)="hoveredFileCatId = fileCat.id"
              (mouseleave)="hoveredFileCatId = null"
            >
              {{ fileCat.name }}
              @if (
                hoveredFileCatId === fileCat.id &&
                (canDeleteFiles ||
                  (isContractorCategory && canDeleteContractorFiles))
              ) {
                @if (
                  canDeleteFiles ||
                  (isContractorCategory && canDeleteContractorFiles)
                ) {
                  <tui-icon
                    icon="@tui.x"
                    class="bg-(--x-color-red) text-white rounded-full cursor-pointer size-6 text-base"
                    tuiHintAppearance="dark"
                    tuiHintDirection="end-top"
                    [tuiHint]="
                      'request_form.files.hint_delete_all_cat_files' | translate
                    "
                    (click)="deleteAllCatFiles(fileCat)"
                  />
                }
              } @else {
                <span
                  tuiBadge
                  class="font-medium! entities-counter-badge"
                  size="l"
                  >{{ getFiles(fileCat.id).length }}</span
                >
              }
            </p>
            <section class="flex items-center gap-4 flex-wrap">
              @for (file of files; track file.id; let index = $index) {
                @let requestedToDelete = fileIsRequestedToDelete(file);
                @let fileCatId = fileCat.id;
                <picture
                  class="relative cursor-pointer"
                  (mouseover)="hoveredFileId = file.id"
                  (mouseleave)="hoveredFileId = null"
                >
                  <div
                    class="w-full h-full rounded-(--tui-radius-xl)"
                    [ngClass]="{
                      'bg-[#FF5C5C80]! opacity-60 absolute z-10':
                        requestedToDelete,
                    }"
                  ></div>
                  <x-file-preview
                    [src]="file.path | filePreviewUrl"
                    [title]="file.filename"
                    [fallback]="
                      fileIsImage(file) ? [getFileUrl(file)] : undefined
                    "
                    [fallbackIcon]="
                      fileIsImage(file) ? '@tui.image' : '@tui.file-text'
                    "
                    [badge]="file.filename | fileExtension"
                    (click)="
                      fileIsImage(file)
                        ? showImagePreview(file, fileCatId, index)
                        : downloadFile(file)
                    "
                  ></x-file-preview>
                  @if (hoveredFileId === file.id) {
                    <ng-container
                      [ngTemplateOutlet]="deleteFileTemplate"
                      [ngTemplateOutletContext]="{
                        file,
                        requestedToDelete,
                        small: true,
                        red: true,
                      }"
                    />
                  }
                </picture>
              }
            </section>
          </div>
        } @empty {
          <x-empty-block
            [title]="
              'request_form.files.media_or_mixed_file_cats_empty_message'
                | translate
            "
          />
        }
      </div>
    </section>
  </div>
} @else {
  <section>
    @if (!filesForCustomer) {
      <h6 class="typo-h6 font-extrabold ms-3.5 mb-4">
        {{ 'request_form.files.photos' | translate }}
      </h6>
      @for (fileCat of fileCats; track fileCat.id; let first = $first) {
        @if (isPhotoCat(fileCat.fileRenamePrefix)) {
          <ng-container
            [ngTemplateOutlet]="fileCatTemplate"
            [ngTemplateOutletContext]="{
              fileCat: fileCat,
              first: first,
            }"
          />
        }
      }
      <h6 class="typo-h6 font-extrabold mt-9 ms-3.5">
        {{ 'request_form.files.scans' | translate }}
      </h6>
      @for (fileCat of fileCats; track fileCat.id; let first = $first) {
        @if (isScanCat(fileCat.fileRenamePrefix)) {
          <ng-container
            [ngTemplateOutlet]="fileCatTemplate"
            [ngTemplateOutletContext]="{
              fileCat: fileCat,
              first: first,
            }"
          />
        }
      }
      <h6 class="typo-h6 font-extrabold mt-9 mb-3.5 ms-3.5">
        {{ 'request_form.files.other' | translate }}
      </h6>
      @for (fileCat of fileCats; track fileCat.id; let first = $first) {
        @if (
          !isPhotoCat(fileCat.fileRenamePrefix) &&
          !isScanCat(fileCat.fileRenamePrefix)
        ) {
          <ng-container
            [ngTemplateOutlet]="fileCatTemplate"
            [ngTemplateOutletContext]="{
              fileCat: fileCat,
              first: first,
            }"
          />
        }
      }
    } @else {
      @for (fileCat of fileCats; track fileCat.id; let first = $first) {
        @if (filesExist(fileCat.id)) {
          <ng-container
            [ngTemplateOutlet]="fileCatTemplate"
            [ngTemplateOutletContext]="{
              fileCat: fileCat,
              first: first,
            }"
          />
        } @else {
          <tui-expand [expanded]="expandedNoFileCats">
            <ng-container
              [ngTemplateOutlet]="fileCatTemplate"
              [ngTemplateOutletContext]="{
                fileCat: fileCat,
                first: first,
              }"
            />
          </tui-expand>
        }
      }
      <button
        tuiButton
        type="button"
        (click)="expandFileCatsWithoutFile()"
        appearance="flat"
        class="mx-auto block!"
        size="s"
        [iconEnd]="expandedNoFileCats ? '@tui.chevron-up' : '@tui.chevron-down'"
      >
        <span class="font-medium typo-ui-m">
          {{
            expandedNoFileCats
              ? ('request_form.files.collapse_for_customer_files' | translate)
              : ('request_form.files.expand_for_customer_files' | translate)
          }}
        </span>
      </button>
    }
  </section>
}

<ng-template #fileCatTemplate let-fileCat="fileCat" let-first="first">
  @let files = getFiles(fileCat.id);
  @let filesExistVar = filesExist(fileCat.id);

  <div
    class="x-card x-card_size_m x-white mt-3.5 filecat-dropzone cursor-pointer"
    [tuiSkeleton]="isLoading && isInitialLoad"
    [ngClass]="{ 'mt-0!': first }"
    (dragover)="canUploadFiles ? onDragOver($event) : $event.preventDefault()"
    (dragleave)="canUploadFiles ? onDragLeave($event) : $event.preventDefault()"
    (drop)="canUploadFiles ? onDrop($event, fileCat) : $event.preventDefault()"
    (click)="
      canUploadFiles
        ? fileBlockClick($event, fileInput)
        : $event.preventDefault()
    "
  >
    <section class="flex items-center justify-between">
      <h3 class="typo-ui-l font-bold flex items-center">
        {{ fileCat.name }}
      </h3>
      @if (canUploadFiles) {
        <div class="flex items-center gap-2">
          @if (catUploadInProgress[fileCat.id]) {
            <label tuiProgressLabel>
              <span class="font-bold"
                >{{ catsUploadProgress[fileCat.id] || 0 }}%</span
              >
              <tui-progress-circle
                [max]="100"
                [value]="catsUploadProgress[fileCat.id] || 0"
              ></tui-progress-circle>
              @if ((filesUploadingTotalByCat[fileCat.id] || 0) > 1) {
                <small class="leading-3">
                  {{ filesProcessedCountByCat[fileCat.id] || 0 }} /
                  {{ filesUploadingTotalByCat[fileCat.id] || 0 }}
                </small>
              }
            </label>
          }
          <tui-icon
            [style.border-width.rem]="0.25"
            icon="@tui.plus"
            class="rounded-full cursor-pointer w-[30px]! h-[30px]! ms-1"
            (click)="fileInput.click()"
          ></tui-icon>
        </div>
      }
    </section>
    @if (filesExistVar) {
      <hr class="my-4" />
    }

    <input
      style="display: none"
      type="file"
      [id]="fileCat.id"
      [name]="fileCat.name"
      multiple
      (change)="onFileChanged($event, fileCat)"
      #fileInput
    />

    @if (filesExistVar) {
      @let count = files.length;
      <section class="flex items-center gap-4 flex-wrap">
        @for (file of files; track file.id; let index = $index) {
          @let isCollapsedItem = count > 6 && index > 5;

          @if (isCollapsedItem) {
            <tui-expand [expanded]="fileCatsExpanded[fileCat.id]">
              <ng-container
                [ngTemplateOutlet]="fileTemplate"
                [ngTemplateOutletContext]="{
                  file,
                  insideExpand: true,
                  fileCatId: fileCat.id,
                  index,
                  count,
                }"
              />
            </tui-expand>
          } @else {
            <ng-container
              [ngTemplateOutlet]="fileTemplate"
              [ngTemplateOutletContext]="{
                file,
                fileCatId: fileCat.id,
                index,
                count,
              }"
            />
          }
        }
      </section>
      @if (count > 6) {
        <hr class="mt-4" />
        <button
          tuiButton
          type="button"
          (click)="fileCatsExpanded[fileCat.id] = !fileCatsExpanded[fileCat.id]"
          appearance="flat"
          class="mx-auto block! -mb-1 mt-2"
          size="s"
        >
          <span class="font-medium typo-body-m">
            {{
              fileCatsExpanded[fileCat.id]
                ? ('request_form.files.collapse_for_customer_files' | translate)
                : ('request_form.files.expand_for_customer_files' | translate) +
                  ' ' +
                  count
            }}
          </span>
        </button>
      }
    }
  </div>
</ng-template>

<x-image-preview
  [files]="requestFiles"
  [request]="request"
  [showPreviewImageData]="$showPreviewImage"
/>

<ng-template
  #fileTemplate
  let-file="file"
  let-insideExpand="insideExpand"
  let-fileCatId="fileCatId"
  let-index="index"
>
  @let requestedToDelete = fileIsRequestedToDelete(file);

  <picture
    class="relative cursor-pointer"
    [ngClass]="{ 'static!': insideExpand }"
  >
    <x-file-preview
      [src]="file.path | filePreviewUrl"
      [title]="file.filename"
      [fallback]="fileIsImage(file) ? [getFileUrl(file)] : undefined"
      [fallbackIcon]="fileIsImage(file) ? '@tui.image' : '@tui.file-text'"
      [badge]="file.filename | fileExtension"
      [ngClass]="{ 'opacity-30': requestedToDelete }"
      (click)="
        fileIsImage(file)
          ? showImagePreview(file, fileCatId, index)
          : downloadFile(file)
      "
    ></x-file-preview>
    <ng-container
      [ngTemplateOutlet]="deleteFileTemplate"
      [ngTemplateOutletContext]="{ file, requestedToDelete }"
    />
  </picture>
</ng-template>

<ng-template
  #deleteFileTemplate
  let-file="file"
  let-requestedToDelete="requestedToDelete"
  let-small="small"
  let-red="red"
>
  @let isContractorCategory = file.catId.isContractorFileCat;
  @if (
    (canDeleteFiles || (isContractorCategory && canDeleteContractorFiles)) &&
    !requestedToDelete
  ) {
    <button
      appearance="icon"
      [iconStart]="small ? '@tui.x' : '@tui.x'"
      tuiIconButton
      type="button"
      [size]="small ? 'xs' : 's'"
      class="remove-icon-btn"
      [ngClass]="{ 'x-bg-red': red, 'bg-[#8D8F9F]!': !red }"
      tuiHintAppearance="dark"
      [tuiHint]="
        ('request_form.files.hint_delete_file' | translate) + file?.filename
      "
      (click)="deleteFile(file, $event)"
    ></button>
  } @else if (!requestedToDelete) {
    <button
      appearance="icon"
      [iconStart]="small ? '@tui.x' : '@tui.x'"
      tuiIconButton
      type="button"
      [size]="small ? 'xs' : 's'"
      class="remove-icon-btn"
      [ngClass]="{ 'x-bg-red': red, 'bg-[#8D8F9F]!': !red }"
      tuiHintAppearance="dark"
      [tuiHint]="
        ('request_form.files.hint_request_to_delete' | translate) +
        file.filename
      "
      (click)="createFileDeleteRequest(file)"
    ></button>
  }
  @if (requestedToDelete) {
    <button
      appearance="icon"
      [iconStart]="small ? '@tui.x' : '@tui.x'"
      tuiIconButton
      type="button"
      size="s"
      tuiHintAppearance="dark"
      class="remove-icon-btn x-bg-red"
      [tuiHint]="
        ('request_form.files.hint_cancel_request_to_delete' | translate) +
        file.filename
      "
      (click)="createFileDeleteRequest(file)"
    ></button>
  }
</ng-template>

<ng-template #allFilesModalTemplate>
  <header>
    <h1 class="font-extrabold text-[28px]/[24px]">
      @if (filesForCustomer) {
        {{ 'request_form.files.files_modal_title_from_customer' | translate }}
      } @else {
        {{ 'request_form.files.files_modal_title_from_client' | translate }}
      }
    </h1>
  </header>
  <section class="mt-10">
    @if (!filesForCustomer) {
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.photos',
          filterFn: isPhotoCat.bind(this),
          filterFnParam: 'fileRenamePrefix',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.scans',
          filterFn: isScanCat.bind(this),
          filterFnParam: 'fileRenamePrefix',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.other',
          filterFn: filterOtherFiles.bind(this),
        }"
      ></ng-container>
    } @else {
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.important',
          filterFn: isImportantCat.bind(this),
          filterFnParam: 'id',
        }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="fileCatSectionTemplate"
        [ngTemplateOutletContext]="{
          title: 'request_form.files.other',
          filterFn: filterNonImportantFiles.bind(this),
          filterFnParam: 'id',
        }"
      ></ng-container>
    }
  </section>
</ng-template>

<ng-template #fileCatForModalTemplate let-fileCat="fileCat">
  <div
    class="x-card x-card_size_m x-white filecat-dropzone cursor-pointer h-[180px] w-[200px] box-border"
    [tuiSkeleton]="isLoading && isInitialLoad"
    (dragover)="canUploadFiles ? onDragOver($event) : $event.preventDefault()"
    (dragleave)="canUploadFiles ? onDragLeave($event) : $event.preventDefault()"
    (drop)="canUploadFiles ? onDrop($event, fileCat) : $event.preventDefault()"
    (click)="
      canUploadFiles
        ? fileBlockClick($event, fileInput)
        : $event.preventDefault()
    "
    [tuiHint]="fileCat.name"
    tuiHintAppearance="dark"
  >
    <section class="flex items-start justify-between">
      <tui-scrollbar class="max-h-[150px]">
        <h3 class="x-font-body-2">
          {{ fileCat.name }}
        </h3>
      </tui-scrollbar>
      @if (canUploadFiles) {
        <div class="flex items-center gap-2">
          <div class="flex justify-between h-[150px] items-center flex-col">
            <tui-icon
              [style.border-width.rem]="0.25"
              icon="@tui.plus"
              class="rounded-full cursor-pointer w-[30px]! h-[30px]! ms-1"
              (click)="fileInput.click()"
            ></tui-icon>
            @if (catUploadInProgress[fileCat.id]) {
              <label tuiProgressLabel>
                <span class="font-bold"
                  >{{ catsUploadProgress[fileCat.id] || 0 }}%</span
                >
                <tui-progress-circle
                  [max]="100"
                  [value]="catsUploadProgress[fileCat.id] || 0"
                ></tui-progress-circle>
                @if ((filesUploadingTotalByCat[fileCat.id] || 0) > 1) {
                  <small class="leading-3">
                    {{ filesProcessedCountByCat[fileCat.id] || 0 }} /
                    {{ filesUploadingTotalByCat[fileCat.id] || 0 }}
                  </small>
                }
              </label>
            }
            @if (filesExist(fileCat.id)) {
              <span
                tuiBadge
                class="mx-1 font-medium! mb-1 entities-counter-badge"
                size="l"
                >{{ getFiles(fileCat.id).length }}</span
              >
            }
          </div>
        </div>
      }
    </section>

    <input
      style="display: none"
      type="file"
      [id]="fileCat.id"
      [name]="fileCat.name"
      multiple
      (change)="onFileChanged($event, fileCat)"
      #fileInput
    />
  </div>
</ng-template>

<ng-template
  #fileCatSectionTemplate
  let-title="title"
  let-filterFn="filterFn"
  let-filterFnParam="filterFnParam"
>
  <h6 class="x-font-body-1-bold mt-10 my-5">
    {{ title | translate }}
  </h6>
  <section class="flex gap-5 flex-wrap max-w-[calc(200px*6+5*1.25rem)]">
    @for (fileCat of fileCats; track fileCat.id) {
      @if (
        filterFn(
          filterFnParam ? getFileCatValue(fileCat, filterFnParam) : fileCat
        )
      ) {
        <ng-container
          [ngTemplateOutlet]="fileCatForModalTemplate"
          [ngTemplateOutletContext]="{ fileCat }"
        />
      }
    }
  </section>
</ng-template>
